export function safeId(p) {
  return p?.id ?? p?._id ?? null;
}

export function resolveShopProductId(product) {
  const explicitCandidates = [
    product?.productId,
    product?.product_id,
    product?.product?.id,
    product?.product?._id,
  ];

  for (const candidate of explicitCandidates) {
    if (candidate === null || candidate === undefined) continue;
    const normalized = String(candidate).trim();
    if (normalized) return normalized;
  }

  // Avoid treating order-line ids as product ids when the payload lacks a real product reference.
  if (product?.orderId != null || product?.order_id != null) {
    return null;
  }

  const fallbackCandidates = [product?.id, product?._id];

  for (const candidate of fallbackCandidates) {
    if (candidate === null || candidate === undefined) continue;
    const normalized = String(candidate).trim();
    if (normalized) return normalized;
  }

  return null;
}

export function getShopProductPath(product) {
  const productId = resolveShopProductId(product);
  return productId ? `/product/${encodeURIComponent(productId)}` : null;
}

export function safeName(p) {
  return p?.name ?? p?.title ?? "Untitled";
}

export function safePrice(p) {
  if (Number.isFinite(p?.price)) return Number(p.price);
  if (Number.isFinite(p?.base_price)) return Number(p.base_price);
  if (Number.isFinite(p?.base_price_cents)) return Number(p.base_price_cents) / 100;
  if (Number.isFinite(p?.price_cents)) return Number(p.price_cents) / 100;
  return 0;
}

export function safeImage(p) {
  return p?.image || p?.primary_image || p?.thumbnail || null;
}

function finiteNumber(value) {
  if (value === null || value === undefined || typeof value === "boolean") return null;
  if (typeof value === "string" && !value.trim()) return null;

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

export function safeStock(p) {
  const candidates = [p?.stock, p?.quantity, p?.available_stock];

  for (const candidate of candidates) {
    const parsed = finiteNumber(candidate);
    if (parsed !== null) return parsed;
  }

  return null;
}

export function isProductOutOfStock(product) {
  const stock = safeStock(product);
  return stock !== null && stock <= 0;
}
